class ProductTabs extends HTMLElement {
  constructor() {
   super();
  }
  connectedCallback() {
    this.titles = this.querySelectorAll('.product-tabs-new__title');
    this.contents = this.querySelectorAll('.product-tabs-new__content');

    if (!this.titles.length || !this.contents.length) return;

    this.bindEvents();
  }
  bindEvents() {
    this.titles.forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.tabIndex;

        this.titles.forEach((b) => b.classList.remove('active'));
        this.contents.forEach((c) => c.classList.remove('active'));

        button.classList.add('active');
        const targetContent = this.querySelector(`.product-tabs-new__content[data-tab-index="${index}"]`);
        if (targetContent) targetContent.classList.add('active');
      });
    });
  }
}

customElements.define('product-tabs-new', ProductTabs);